import { FlagsToggle } from 'flags'

export const PUBLISHED_CONTENT_FLAG =
  'feature_LEARN-28743-learn-curriculum-service-published-content'

// Shared "k12 core curriculum-service integration" flag. Also gates the HS
// dashboard migration (see HighSchoolProgramCard/InstanceView/hsDashboardDataSource.js).
export const K12_CORE_CURRICULUM_SERVICE_FLAG =
  'feature_LEARN-28473-learn-k12-core-curriculum-service-integration'

export const EXPORT_BUTTON_UPDATE_FLAG =
  'feature_LEARN-29157-export-button-update'

export const HS_SITE_REPORTS_LESSON_PAGE_FLAG =
  'feature_LEARN-29341-hs-site-reports-lesson-page'

export const SUBNAV_BREADCRUMBS_FLAG = 'feature_LEARN-18963-subnav-breadcrumbs'

export const isFlagOn = (flagSubcriptions = []) => {
  try {
    return FlagsToggle({
      flagSubcriptions,
      onCode: () => true,
      offCode: () => false,
    })()
  } catch {
    return false
  }
}
